import WhyChoseUs1 from '@/assets/images/digital-wallet/why-chose-us-1.png'
import WhyChoseUs2 from '@/assets/images/digital-wallet/why-chose-us-2.png'
import WhyChoseUs3 from '@/assets/images/digital-wallet/why-chose-us-3.png'

export const SLIDES = [
  {
    title: 'whyChoseUs.slides.slide1.title',
    content: 'whyChoseUs.slides.slide1.content',
    image: WhyChoseUs1
  },
  {
    title: 'whyChoseUs.slides.slide2.title',
    content: 'whyChoseUs.slides.slide2.content',
    image: WhyChoseUs2
  },
  {
    title: 'whyChoseUs.slides.slide3.title',
    content: 'whyChoseUs.slides.slide3.content',
    image: WhyChoseUs3
  }
]
